import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";
import FieldsEmployeePushNotification from "graphql/fields/FieldsEmployeePushNotification";

const fields = {
	'guid': 'String!',
	'active': 'String',
};

export default gql(`
	mutation employee_push_notification( ${ HelperGraphql.createFields( fields ) } ) {
	    employee_push_notification( ${ HelperGraphql.createVariables( fields ) } ) {
	        ${FieldsEmployeePushNotification}
	    }
	}
`);

